/**
 * Imagery notice (snippets/omi-image-note.liquid): the ⓘ opens on hover (CSS), keyboard focus (CSS)
 * and tap/click (here). Clicks stay inside the notice so galleries don't open their zoom or swipe.
 */
class OmiImageNote extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button || this.dataset.ready) return;
    this.dataset.ready = 'true';
    for (const type of ['click', 'pointerdown', 'pointerup', 'mousedown', 'touchstart']) {
      this.addEventListener(type, (event) => event.stopPropagation(), { passive: type === 'touchstart' });
    }
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle(!this.classList.contains('is-open'));
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.toggle(false);
        this.button.focus();
      }
    });
  }

  /** @param {boolean} open */
  toggle(open) {
    if (open) document.querySelectorAll('omi-image-note.is-open').forEach((n) => n !== this && n.toggle(false));
    this.classList.toggle('is-open', open);
    this.button.setAttribute('aria-expanded', String(open));
  }
}

if (!customElements.get('omi-image-note')) customElements.define('omi-image-note', OmiImageNote);

document.addEventListener('click', () => {
  document.querySelectorAll('omi-image-note.is-open').forEach((n) => /** @type {OmiImageNote} */ (n).toggle(false));
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('omi-image-note.is-open').forEach((n) => /** @type {OmiImageNote} */ (n).toggle(false));
});
